import { ExtendedPriceTypeData } from './types';

function getUniqueArray<T>(value: Array<T>) {
  return Array.from(new Set(value).values());
}

export default function getPriceRangeForPriceTypes(priceTypes: ExtendedPriceTypeData[]) {
  const allPrices = priceTypes.map((priceType) => priceType.priceWithFee);

  if (allPrices.length === 1) {
    return allPrices;
  }

  const uniquePrices = getUniqueArray(allPrices);

  uniquePrices.sort((a, b) => a - b);

  return uniquePrices;
}
